import {
    projectOService
} from 'shared/api/services/BEX';

class UnifiedModelWebsocketService {
    /**
     * Runs an experiment using the model.
     * @param {Object} data - The experiment data to run.
     * @param {String} model_type - The model type to use from ["IBM", "Groq"]
     * @returns {Promise<Object>} The response containing experiment results.
     */
    async experiment(data, model_type, orgId = '', subOrgId = '') {
        const orgParams = orgId ? `&org_id=${orgId}&sub_org_id=${subOrgId}` : '';
        const response = await projectOService.performRequest(`projecto/config/api/v1/instructions/experiment?model_type=${model_type}${orgParams}`, {
            method: 'POST',
            data
        });
        return response;
    }

    /**
     * Runs a prediction using the model.
     * @param {Object} data - The predict data to run.
     * @param {String} model_type - The model type to use from ["IBM", "Groq"]
     * @returns {Promise<Object>} The response containing predict results.
     */
    async predict(data, model_type) {
        const response = await projectOService.performRequest(`projecto/config/api/v1/instructions/predict?model_type=${model_type}`, {
            method: 'POST',
            data
        });
        return response;
    }
}

const unifiedModelWSService = new UnifiedModelWebsocketService();
export { unifiedModelWSService };